module.exports = __webpack_public_path__ + "img/login-top.766d48af.png";